import React, { useEffect, useState } from 'react';
import { stopLoadingSpinner } from "../../csf-ufc-pivotal/includes/utils";
import PivotalFormApi from "../../../js/csf/pivotal/PivotalFormApi";
import {
  handleFileInput,
  handleClearFileInput,
  handleFileInputDefault,
  convertBase64,
  resetErrMessages,
  removeErrFromValidItems,
  removeErrFromFileInput
} from '../includes/utils';
import PropTypes from "prop-types";
import PivotalSearchApi from "../../../js/csf/pivotal/PivotalSearchApi";
import { CsfPivotalFournisseurFormateurListModal } from "./csf-fournisseur-gestion-formateur-add-to-list";
import PivotalAttachmentsApi from "../../../js/csf/pivotal/PivotalAttachmentsApi";
import JustValidate from 'just-validate';

export function CsfPivotalFournisseurFormateurModal({
  type,
  editTrainer,
  apiUrl,
  apiEnv,
  accessToken,
  handleAddCreateTrainerList,
  addToList,
  listId,
  title,
  resetEditTrainer,
  ipfErrorMat,
  isError,
  setIpfErrorMat,
  setIsError
}) {

  const defaultValue = {
    'First_Name': "",
    'Last_Name': "",
    'GSFT_Correspondence_Language': 0,
    'Contact_Email': "",
    'GSFT_NoClientAMF': "",
    'GSFT_Status_Id': "AAAAAAAAADg=",
    'EP_DossierDiscipline': false,
    'EP_Financial_Plan': false,
    'EP_LinkedIn': "",
    'EP_Old_Sources': false,
    'EP_Resume': false,
    'RN_EP_Resume_FZ': false,
    'EP_Biography': false,
    'RN_EP_Biography_FZ': false,
    'IPF_Matricule_Bridge': ""
  }
  const [lists, setLists] = useState([]);
  const [contactData, setContactData] = useState(defaultValue);
  const [listsBtns, setListsBtns] = useState([]);
  const [originalListsBtns, setOriginalListsBtns] = useState([]);
  const [filesBase64, setFilesBase64] = useState({ 'EP_Resume': '', 'EP_Biography': '' });
  const [fileUploaded, setFileUploaded] = useState(false);
  const [updateTrainer, setUpdateTrainer] = useState(false);
  const [notEnoughReference, setNotEnoughReference] = useState(false);
  const [validator, setValidator] = useState(null);
  const [isAMF, setIsAMF] = useState(null);

  const inactiveStatus = 'AAAAAAAAAEg=';

  /*
    * Setup form validation
    * */
  useEffect(() => {
    if (validator) {
      // destroy existing validator before setting new rules conditionally
      validator.destroy();
    }
    const justValidate = new JustValidate('#createEditFormateur');

    if (contactData.GSFT_Status_Id === inactiveStatus) {
      // remove all validations when is inactive
      justValidate.destroy();
    } else {
      justValidate
        .addField('#First_Name', [
          {
            rule: 'required',
            errorMessage: window.Drupal.t('fournisseur.creation_form.validation.required'),
          },
        ])
        .addField('#Last_Name', [
          {
            rule: 'required',
            errorMessage: window.Drupal.t('fournisseur.creation_form.validation.required'),
          },
        ])
        .addField('#Contact_Email', [
          {
            rule: 'required',
            errorMessage: window.Drupal.t('fournisseur.creation_form.validation.required'),
          },
          {
            rule: 'email',
            errorMessage: window.Drupal.t('fournisseur.creation_form.validation.email'),
          },
        ])
        .addField('#EP_Old_Sources', [
          {
            rule: 'required',
            errorMessage: window.Drupal.t('fournisseur.creation_form.validation.required'),
          },
        ]);
      if (isAMF) {
        justValidate.addField('#GSFT_NoClientAMF', [
          {
            rule: 'required',
            errorMessage: window.Drupal.t('fournisseur.creation_form.validation.required'),
          },
        ]);
      }
      if (contactData.EP_Financial_Plan) {
        justValidate.addField('#IPF_Matricule_Bridge', [
          {
            rule: 'required',
            errorMessage: window.Drupal.t('fournisseur.creation_form.validation.required'),
          },
        ]);
      }
    }

    setValidator(justValidate);
  }, [isAMF, contactData, contactData?.GSFT_Status_Id]);

  useEffect(() => {
    if (notEnoughReference === true && contactData?.GSFT_Status_Id !== inactiveStatus) {
      markReferencesWithError();
    } else {
      removeErrFromFileInput();
      const referenceLinkedin = document.getElementById('EP_LinkedIn');
      referenceLinkedin.classList.remove('just-validate-error-field');
    }
  }, [notEnoughReference, contactData?.GSFT_Status_Id]);

  /*
  * When the edit button is press, fetch the info of te current trainer
  * */
  useEffect(() => {
    if (editTrainer !== '' && accessToken !== '') {
      getTrainerInfo();
    } else {
      if (addToList === true && listId !== '' && title !== '') {
        setListsBtns([{
          id: listId,
          list: title,
          bridge_id: ''
        }]);
      } else {
        setListsBtns([]);
      }
      handleClearFileInput('EP_Biography');
      handleClearFileInput('EP_Resume');
      setIsAMF(false);
      setContactData(defaultValue);
    }
    setNotEnoughReference(false);
    handleFileInput();
  }, [editTrainer]);

  /*
  * Init the bootstrap tooltips for custom input file
  * */
  useEffect(() => {
    $('[data-toggle="tooltip"]').tooltip({
      customClass: 'sup-tooltip'
    });

    $("#createEditFormateur").on("hide.bs.modal", function () {
      setIsAMF(null);
      // TODO : This function call is removed because is causes an error.
      // it should by passed to the component to reset the modal form data,
      // but somehow is null.
      // For now, the popup will close, but will keep the previous data if re-opened.
      // resetEditTrainer();
      if (validator) {
        resetErrMessages();
      }
    });

  });

  /*
  * When the accessToken is fetched and state is updates, get the connected user
  * */
  useEffect(() => {
    if (accessToken) {
      getAllLists();
    }
  }, [accessToken]);

  useEffect(() => {
    if (updateTrainer === true) {
      updateFormateur();
    }
  }, [updateTrainer]);

  /*
  * Makes all references in error state
  * */
  function markReferencesWithError() {
    const references = document.querySelectorAll('.file-custom, #EP_LinkedIn');
    references.forEach(reference => {
      reference.classList.add('just-validate-error-field');
    });
  }

  /*
  * Get all the list to populate the list modal
  * */
  function getAllLists() {
    const pivotalSearchApi = new PivotalSearchApi(apiUrl, apiEnv, accessToken);
    const requestData = {
      ParameterValues: [""],
      search: 'CSF_EP_UxContactLists_REST',
      searchResultsList: 'CSF_EP_ContactLists_SRL'
    };

    pivotalSearchApi.callSearchEndpoint(requestData, '_Espace_Partenaire')
      .then(response => {
        if (response?.success && response?.payload?.data?.rows?.length >= 0) {
          const options = response.payload.data.rows;
          const formattedOptions = [];

          options.forEach(function (option) {
            formattedOptions.push({
              label: option.List_Name !== null ? option.List_Name : "",
              value: option.CSF_EP_List_Id
            });
          });

          setLists(formattedOptions);
          stopLoadingSpinner();
        }
        stopLoadingSpinner();
      })
      .catch(error => {
        stopLoadingSpinner();
        console.error(error);
      });
  }

  /*
  * add selected list to the list button field
  * */
  const addListsButtons = (lists) => {
    setListsBtns((prevButtons) => [
      ...prevButtons,
      ...lists.map((list) => ({
        id: list.value,
        list: list.label,
        bridge_id: ''
      }))
    ]);
  };

  /*
  * hande when the modal of list is closed to pupolate the buttons
  * */
  useEffect(() => {
    const handleModalClose = () => {
      const checkedLists = document.querySelectorAll('input[name="listSelected"]:checked');
      const selectedLists = Array.from(checkedLists).map(checkbox => ({
        value: checkbox.value,
        label: checkbox.getAttribute('data-label') // Assuming the label is stored in a data attribute
      }))
      addListsButtons(selectedLists);
    };

    // Remove default Bootstrap event listener
    $('#addFormateurToList').off('hidden.bs.modal');
    // Do our own stuff
    $('#addFormateurToList').on('click', '#modalSaveButton', function (e) {
      handleModalClose();
      $('#addFormateurToList').modal('hide');
    });
  }, []);

  /*
  * handle the delete button of the individual list
  * */
  const handleDelete = (id) => {
    setListsBtns(listsBtns.filter((button) => button.id !== id));
  };

  /*
  * Method to fetch the trainer info.
  * */
  function getTrainerInfo() {
    const requestData = {
      form: 'CSF_EP_UXContact_Info',
      recordId: editTrainer,
    };
    const pivotalFormApi = new PivotalFormApi(apiUrl, apiEnv, accessToken);
    pivotalFormApi.callFormRecuperationEndpoint(requestData, '_Espace_Partenaire')
      .then(response => {
        if (response?.success && response?.payload?.data?.primary?.Contact_Id) {
          setContactData({
            'First_Name': response.payload.data.primary.First_Name !== null ? response.payload.data.primary.First_Name : "",
            'Last_Name': response.payload.data.primary.Last_Name !== null ? response.payload.data.primary.Last_Name : "",
            'GSFT_Correspondence_Language': response.payload.data.primary.GSFT_Correspondence_Language !== null ? response.payload.data.primary.GSFT_Correspondence_Language : 0,
            'Contact_Email': response.payload.data.primary.Email !== null ? response.payload.data.primary.Email : "",
            'GSFT_NoClientAMF': response.payload.data.primary.GSFT_NoClientAMF !== null ? response.payload.data.primary.GSFT_NoClientAMF : "",
            'GSFT_Status_Id': response.payload.data.primary.GSFT_Status_Id !== null ? response.payload.data.primary.GSFT_Status_Id : "AAAAAAAAADg=",
            'EP_DossierDiscipline': response.payload.data.primary.EP_DossierDiscipline !== null ? response.payload.data.primary.EP_DossierDiscipline : false,
            'EP_Financial_Plan': response.payload.data.primary.EP_Financial_Plan !== null ? response.payload.data.primary.EP_Financial_Plan : false,
            'EP_LinkedIn': response.payload.data.primary.EP_LinkedIn !== null ? response.payload.data.primary.EP_LinkedIn : "",
            'EP_Old_Sources': response.payload.data.primary.EP_Old_Sources !== null ? response.payload.data.primary.EP_Old_Sources : false,
            'EP_Resume': response.payload.data.primary.EP_Resume !== null ? response.payload.data.primary.EP_Resume : "",
            'EP_Biography': response.payload.data.primary.EP_Biography !== null ? response.payload.data.primary.EP_Biography : "",
            'RN_EP_Resume_FZ': response.payload.data.primary.RN_EP_Resume_FZ !== null ? response.payload.data.primary.RN_EP_Resume_FZ : "",
            'RN_EP_Biography_FZ': response.payload.data.primary.RN_EP_Biography_FZ !== null ? response.payload.data.primary.RN_EP_Biography_FZ : "",
            'IPF_Matricule_Bridge': response.payload.data.primary.IPF_Matricule_Bridge !== null ? response.payload.data.primary.IPF_Matricule_Bridge : "",
          });
          const newlistsbtn = response.payload.data.primary.CSF_EP_List__Secondary.map(item => ({
            id: item.CSF_EP_List_Id,
            list: item.CSF_EP_List_Id__Rn_Descriptor,
            bridge_id: item.CSF_EP_List_Contact_Bridge_Id
          }));
          setOriginalListsBtns(newlistsbtn);
          setListsBtns(newlistsbtn);

          const amfNumber = response.payload.data.primary.GSFT_NoClientAMF;
          if (amfNumber && amfNumber !== "") {
            setIsAMF(true);
          } else {
            setIsAMF(false);
          }

          if (response.payload.data.primary.EP_Resume) {
            handleFileInputDefault('EP_Resume', response.payload.data.primary.EP_Resume, response.payload.data.primary.RN_EP_Resume_FZ);
          } else {
            handleClearFileInput('EP_Resume');
          }

          if (response.payload.data.primary.EP_Biography) {
            handleFileInputDefault('EP_Biography', response.payload.data.primary.EP_Biography, response.payload.data.primary.RN_EP_Biography_FZ);
          } else {
            handleClearFileInput('EP_Biography');
          }
        }
      })
      .catch(error => {
        stopLoadingSpinner();
        console.error(error);
      });
  }

  /*
  * Method that handle the on change values
  * */
  function handleOnChangeValues(event) {
    let eventValue = event.target.value;
    if (event.target.type === 'checkbox') {
      eventValue = event.target.checked;
    }
    setContactData({ ...contactData, [event.target.name]: eventValue });
  }

  /*
  * Method that handle the change on the input file type
  * */
  function handleFileInputUpload(event) {
    const file = event.target.files[0];
    const uploadName = event.target.name;
    const lastModifiedDateTime = new Date(file.lastModifiedDate);
    const fileInfo = {
      [`${uploadName}`]: file.name,
      [`RN_${uploadName}_FN`]: file.name.split('.').slice(0, -1).join('.'),
      [`RN_${uploadName}_FZ`]: file.size,
      [`RN_${uploadName}_ED`]: `${lastModifiedDateTime.getMonth() + 1}/${lastModifiedDateTime.getDate()}/${lastModifiedDateTime.getFullYear()}`,
      [`RN_${uploadName}_ET`]: `${lastModifiedDateTime.getHours()}:${lastModifiedDateTime.getMinutes()}:${lastModifiedDateTime.getSeconds()}`,
      [`RN_${uploadName}_EX`]: file.type.split("/")[1]
    };
    setContactData({ ...contactData, ...fileInfo });
    convertDocumentToBase64(file, uploadName);
  }

  /*
  * Method that call the method to convert the file into base64 and update the state value
  * */
  const convertDocumentToBase64 = async (file, uploadName) => {
    const base64 = await convertBase64(file);
    setFilesBase64({ ...filesBase64, [uploadName]: base64 });
    setFileUploaded(true);
  };

  /*
  * Method that deletes a key from the contactData (used for file input's file info)
  * */
  function deletefileInfoKey(param) {
    const newcontactData = contactData;
    delete newcontactData[param];
    setContactData(newcontactData);
  };

  /*
  * Method triggered when a user clicks to delete the file from an input
  * */
  function handleResetFileInput(e) {
    e.preventDefault();
    const customFile = e.target.closest('.file-custom');
    const inputFile = customFile.querySelector('input[type="file"]');
    const inputId = inputFile.id;

    // Clears the input and filename
    handleClearFileInput(inputId);
    const uploadName = inputFile.id;

    // Remove all fileInfo
    deletefileInfoKey(`RN_${uploadName}_FN`);
    deletefileInfoKey(`RN_${uploadName}_FZ`);
    deletefileInfoKey(`RN_${uploadName}_ED`);
    deletefileInfoKey(`RN_${uploadName}_ET`);
    deletefileInfoKey(`RN_${uploadName}_EX`);
    setContactData({ ...contactData, [`${uploadName}`]: false });

    setFilesBase64({ ...filesBase64, [`${uploadName}`]: '' });
    setFileUploaded(false);
  }

  /*
  * Method that handle click on create or edit a trainer, it will first check if a documents was uploaded
  * */
  function handleCreateEditFormateur(e) {
    e.preventDefault();
    const requiredKeys = ["EP_Resume", "EP_Biography", "EP_LinkedIn"];
    const countNotEmpty = requiredKeys.filter(key => contactData[key] && contactData[key].trim() !== '').length;

    // Reset (without this, modal submit only once)
    setUpdateTrainer(false);

    if (countNotEmpty >= 1 || contactData?.GSFT_Status_Id === inactiveStatus) {
      setNotEnoughReference(false);
    } else {
      setNotEnoughReference(true);
    }

    if (validator) {
      validator.validate();
      setTimeout(() => {
        // inactive doesn't require validation
        if (contactData?.GSFT_Status_Id === inactiveStatus || (validator?.isValid && countNotEmpty >= 1 )) {
          if (fileUploaded === true) { // run this function if some of the uploaded files were used
            uploadDocuments();
          } else {
            setUpdateTrainer(true);
          }
        } else {
          console.error('Form validation failed!');
        }
      });
    }
  }

  /*
  * Method that handle the edit or the creation of a formateur
  * */
  function updateFormateur() {

    let requestData = {
      form: 'CSF_EP_UXContact_REST',
      deltaData: contactData
    };

    if (editTrainer !== '') {
      requestData.recordId = editTrainer;
    }

    if(contactData.EP_Financial_Plan === false){
      contactData.IPF_Matricule_Bridge = null;
    }

    const pivotalFormApi = new PivotalFormApi(apiUrl, apiEnv, accessToken);
    pivotalFormApi.callFormPutEndpoint(requestData, '_Espace_Partenaire')
      .then(response => {
        if (response?.success && response?.payload?.data?.primary?.Contact_Id) {
          handleAddingOrDeleteTrainerToList(response.payload.data.primary.Contact_Id);
          if (addToList === true) {
            window.location.reload();
          }
          if (addToList !== true) {
            if (type !== 'form') {
              window.location.reload();
            }
          }
          $("[data-dismiss=modal]").trigger({ type: "click" });
        } else {
          setIsError(true);
          stopLoadingSpinner();
          setIpfErrorMat(response.errorText?.includes("ERR_EP_IPF_MAT_01") ?? false);
          console.error(response.errorText);
        }
      })
      .catch(error => {
        setIsError(true);
        stopLoadingSpinner();
        console.error(error);
      });
  }

  /*
  * Method that will upload the base64 documents to pivotal and return a uploadID
  * */
  function uploadDocuments() {
    const uploadPromises = [];
    Object.entries(filesBase64).forEach(([key, file]) => {
      if (file !== '') {
        const requestData = {
          "uploadFileBase64": file
        }
        const pivotalAttachmentApi = new PivotalAttachmentsApi(apiUrl, apiEnv, accessToken);
        const promise = pivotalAttachmentApi.callTaskUploadEndpoint(requestData, '_Espace_Partenaire')
          .then(response => {
            return { [key + '__UploadID']: response.payload.uploadID };
          })
          .catch(error => {
            setIsError(true);
            console.error('Error during file upload:', error);
          });
        uploadPromises.push(promise);
      }
    });

    // Return a Promise that resolves when all fetch calls are completed
    return Promise.all(uploadPromises)
      .then((response) => {
        const mergedData = Object.assign({}, contactData, ...response);
        setContactData(mergedData);
        setUpdateTrainer(true) // Return true after all fetch calls are finished
      }).catch(error => {
        setIsError(true);
        console.error('Error during file upload:', error);
      });
  }

  /*
  * Method that handle the adding or the removing of all the specificed list of a created or edited trainer.
  * */
  function handleAddingOrDeleteTrainerToList(trainerId) {
    const removedItems = originalListsBtns.filter(item => !listsBtns.find(newItem => newItem.id === item.id));
    const addedItems = listsBtns.filter(item => !originalListsBtns.find(originalItem => originalItem.id === item.id));
    if (addedItems.length > 0) {
      handleAddingTrainerToList(trainerId, addedItems);
    }
    if (removedItems.length > 0) {
      handleDeleteTrainerToList(trainerId, removedItems);
    }
  }

  /*
  * Method that handle the removing of the trainer from the list
  * */
  function handleDeleteTrainerToList(trainerId, list) {
    list.forEach((list) => {
      stopLoadingSpinner();
      const requestData = {
        form: "CSF_EP_Contact_List_Delete",
        recordId: list.bridge_id, /// might be the bridge id
      };
      const pivotalFormApi = new PivotalFormApi(apiUrl, apiEnv, accessToken);
      pivotalFormApi.callFormDeleteEndpoint(requestData, '_Espace_Partenaire')
        .then(response => {

        })
        .catch(error => {
          console.error(error);
        });
    });
  }

  /*
  * Method that handle the adding of the trainer from the list
  * */
  function handleAddingTrainerToList(trainerId, list) {
    list.forEach((list) => {
      const requestData = {
        form: "CSF_EP_AddContactList_REST",
        recordId: list.id,
        deltaData: {
          CSF_EP_List_Contact_Bridge__Secondary: [{
            CSF_EP_List_Contact_Bridge_Id: "",
            Contact_Id: trainerId
          }]
        }
      };
      const pivotalFormApi = new PivotalFormApi(apiUrl, apiEnv, accessToken);
      pivotalFormApi.callFormPutEndpoint(requestData, "_Espace_Partenaire")
        .then(response => {

        })
        .catch(error => {
          console.error(error);
        });
    });
  }

  /*
  * Method that handle the AMF checkbox, will affect the client number
  * */
  function handleAMFCheckbox(e) {
    if (e.target.checked) {
      setIsAMF(true);
    } else {
      setIsAMF(false);
    }
  }

  return (
    <div>
      <div className="modal fade" id="createEditFormateur" tabIndex="-1" role="dialog"
        aria-labelledby="editFormateurLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h2 id="editFormateurLabel">
                {editTrainer !== '' ? (
                  window.Drupal.t('fournisseur.gestion.table.edit.title')
                ) : (
                  window.Drupal.t('fournisseur.gestion.table.create.title')
                )}

              </h2>
              <button type="button" className="close" data-dismiss="modal"
                aria-label={window.Drupal.t('lang.modal.close')}>
                <i className="icon icon-csf-close-noborder"><span className="d-none">&nbsp;</span></i>
              </button>
            </div>

            <form id="handleCreateEditFormateur" method="post" onSubmit={handleCreateEditFormateur}>
              <div className="modal-body">
                {isError === true && (
                  <div className="alert alert-danger" role="alert"
                    aria-live="polite">{window.Drupal.t('broker.manager.error.message')}</div>
                )}
                <fieldset>
                  <legend
                    className="sr-only">{window.Drupal.t('fournisseur.gestion.table.firstname')} {window.Drupal.t('fournisseur.gestion.table.lastname')}</legend>
                  <div className="row">
                    <div className="col-12 col-xl-6">
                      <div className="form-group">
                        <label htmlFor="First_Name">{window.Drupal.t('fournisseur.gestion.table.firstname')}*</label>
                        <input onChange={handleOnChangeValues} value={contactData['First_Name']}
                          type="text" id="First_Name" name="First_Name"
                          disabled={editTrainer !== '' ? true : false} />
                      </div>
                    </div>
                    <div className="col-12 col-xl-6">
                      <div className="form-group">
                        <label htmlFor="Last_Name">{window.Drupal.t('fournisseur.gestion.table.lastname')}*</label>
                        <input onChange={handleOnChangeValues} value={contactData['Last_Name']}
                          type="text" id="Last_Name" name="Last_Name"
                          disabled={editTrainer !== '' ? true : false} />
                      </div>
                    </div>
                  </div>
                </fieldset>

                <div className="row">
                  <div className="col-12 col-xl-3">
                    <div className="form-group">
                      <label
                        htmlFor="GSFT_Correspondence_Language">{window.Drupal.t('fournisseur.gestion.language.label')}</label>
                      <select onChange={handleOnChangeValues} value={contactData['GSFT_Correspondence_Language']}
                        id="GSFT_Correspondence_Language" name="GSFT_Correspondence_Language">
                        <option value="0">{window.Drupal.t('broker.preferred.language.option.french')}</option>
                        <option value="1">{window.Drupal.t('broker.preferred.language.option.english')}</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-12 col-xl-6">
                    <div className="form-group">
                      <label htmlFor="Contact_Email">{window.Drupal.t('fournisseur.gestion.table.email')}*</label>
                      <input onChange={handleOnChangeValues} value={contactData['Contact_Email']}
                        type="text" id="Contact_Email" name="Contact_Email" />
                    </div>
                  </div>
                  <div className="col-12 col-xl-3">
                    <div className="form-group">
                      <label htmlFor="GSFT_Status_Id">{window.Drupal.t('fournisseur.gestion.status.label')}</label>
                      <select onChange={handleOnChangeValues} value={contactData['GSFT_Status_Id']}
                        id="GSFT_Status_Id" name="GSFT_Status_Id">
                        <option value="AAAAAAAAADg=">{window.Drupal.t('fournisseur.gestion.status.actif')}</option>
                        <option value="AAAAAAAAAEg=">{window.Drupal.t('fournisseur.gestion.status.inactif')}</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12 col-xl-6">
                    <div className="form-group special-padding form-group-checkbox">
                      <input type="checkbox" id="amf" name="amf" onChange={handleAMFCheckbox} checked={isAMF} />
                      <label htmlFor="amf">{window.Drupal.t('fournisseur.gestion.amf.label')}</label>
                    </div>
                  </div>

                  {isAMF === true && (
                    <div className="col-12 col-xl-6">
                      <div className="form-group special-padding mb-0">
                        <label
                          htmlFor="GSFT_NoClientAMF">{window.Drupal.t('fournisseur.gestion.client.amf.label')}*</label>
                        <input onChange={handleOnChangeValues} value={contactData['GSFT_NoClientAMF']}
                          type="text" id="GSFT_NoClientAMF" name="GSFT_NoClientAMF" />
                      </div>
                    </div>
                  )}

                </div>
                <div className="form-group special-padding form-group-checkbox">
                  <input onChange={handleOnChangeValues} checked={contactData['EP_DossierDiscipline']}
                    type="checkbox" id="EP_DossierDiscipline" name="EP_DossierDiscipline" />
                  <label
                    htmlFor="EP_DossierDiscipline">{window.Drupal.t('fournisseur.gestion.dossier.amf.label')}</label>
                </div>
                <div className="row">
                  <div className="col-12 col-xl-7">
                    <div className="form-group special-padding form-group-checkbox">
                      <input onChange={handleOnChangeValues} checked={contactData['EP_Financial_Plan']}
                             type="checkbox" id="EP_Financial_Plan" name="EP_Financial_Plan"/>
                      <label
                        htmlFor="EP_Financial_Plan">{window.Drupal.t('fournisseur.gestion.planificateur.label')}</label>
                    </div>
                  </div>

                  {contactData.EP_Financial_Plan &&
                    <div className="col-12 col-xl-5">
                      <div className="form-group special-padding mb-0">
                        <label
                          htmlFor="IPF_Matricule_Bridge">{window.Drupal.t('fournisseur.gestion.table.matricule')}*</label>
                        <input
                          onChange={handleOnChangeValues}
                          value={contactData['IPF_Matricule_Bridge']}
                          type="text" id="IPF_Matricule_Bridge" name="IPF_Matricule_Bridge"
                          className={ipfErrorMat ? 'custom-error-field' : ''}/>
                        { ipfErrorMat && (
                          <div className="custom-error-label" style={{color: "rgb(184, 17, 17)"}}>
                            {window.Drupal.t('fournisseur.creation_form.form.ipf.error_mat')}
                          </div>
                        )}
                      </div>
                    </div>
                  }
                </div>

                <fieldset className="form-references">
                  <legend>{window.Drupal.t('fournisseur.gestion.reference.title')}</legend>
                  { (notEnoughReference === true && contactData?.GSFT_Status_Id !== inactiveStatus) && (
                    <div className="alert alert-danger" role="alert"
                      aria-live="polite">{window.Drupal.t('fournisseur.require.two.reference')}</div>
                  )}
                  <div className="form-group file-row">
                    <div className="file-custom">
                      <small className="fake-label">{window.Drupal.t('fournisseur.gestion.cv.label')}</small>
                      <input type="hidden" className="file-name" name="" />
                      <input onChange={handleFileInputUpload} type="file" className="visually-hidden" id="EP_Resume"
                        name="EP_Resume" accept=".doc,.docx,.pdf" />
                      <label className="no-style-label" htmlFor="EP_Resume">
                        {window.Drupal.t('fournisseur.gestion.file.btn')}<span
                          className="sr-only"> {window.Drupal.t('fournisseur.gestion.cv.label')}</span>
                      </label>
                      <div className="selectedFile d-none">
                        <span className="visually-hidden">{window.Drupal.t('fournisseur.gestion.file.selected')}: </span>
                        <span className="name"></span>
                        <a href="#" className="removeFile" onClick={handleResetFileInput} data-toggle="tooltip"
                          title={window.Drupal.t('fournisseur.gestion.file.deselected')}><i
                            className="icon icon-remove"></i></a>
                      </div>
                    </div>
                  </div>
                  <div className="form-group file-row">
                    <div className="file-custom">
                      <small className="fake-label">{window.Drupal.t('fournisseur.gestion.bio.label')}</small>
                      <input type="hidden" className="file-name" name="" />
                      <input onChange={handleFileInputUpload} type="file" className="visually-hidden" id="EP_Biography"
                        name="EP_Biography" accept=".doc,.docx,.pdf" />
                      <label className="no-style-label" htmlFor="EP_Biography">
                        {window.Drupal.t('fournisseur.gestion.file.btn')}<span
                          className="sr-only"> {window.Drupal.t('fournisseur.gestion.bio.label')}</span>
                      </label>
                      <div className="selectedFile d-none">
                        <span className="visually-hidden">{window.Drupal.t('fournisseur.gestion.file.selected')} : </span>
                        <span className="name"></span>
                        <a href="#" className="removeFile" onClick={handleResetFileInput} data-toggle="tooltip"
                          title={window.Drupal.t('fournisseur.gestion.file.deselected')}><i
                            className="icon icon-remove"></i></a>
                      </div>
                      <div className="statusMessageUploaded visually-hidden" aria-live="polite"><span
                        className="name"> {window.Drupal.t('fournisseur.gestion.file.uploaded')}</span></div>
                      <div className="statusMessageDeleted visually-hidden" aria-live="polite"><span
                        className="name"> {window.Drupal.t('fournisseur.gestion.file.deleted')}</span></div>
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="EP_LinkedIn">{window.Drupal.t('fournisseur.gestion.client.linkedin.label')}</label>
                    <input onChange={handleOnChangeValues} type="text" value={contactData['EP_LinkedIn']}
                      id="EP_LinkedIn" name="EP_LinkedIn" />
                  </div>
                  <div className="form-group d-flex align-items-center flex-wrap">
                    <input onChange={handleOnChangeValues} checked={contactData['EP_Old_Sources']}
                      type="checkbox" id="EP_Old_Sources" name="EP_Old_Sources" />
                    <label htmlFor="EP_Old_Sources">{window.Drupal.t('fournisseur.gestion.declaration.label')}*</label>
                  </div>
                </fieldset>

                <div className="form-group">
                  <small className="fake-label">{window.Drupal.t('fournisseur.gestion.related.list.label')}</small>
                  <div className="button-container">
                    {listsBtns.map((button) => (
                      <button key={button.id} className="button btn-outlined btn-region" type="button"
                        data-lists={button.list} onClick={() => handleDelete(button.id)}>
                        <span>{button.list}</span>
                        <img src="/themes/custom/tink/dist/assets/icn-delete.svg" alt="" className='btn-delete' />
                      </button>
                    ))}
                    <button type="button" className="button btn-icon-only" data-toggle="modal"
                      data-target="#addFormateurToList">
                      <img src="/themes/custom/tink/dist/assets/icn-add.svg" alt="" />
                    </button>
                  </div>
                </div>
              </div>

              <div className="modal-footer justify-content-end">
                <input className="button btn-submit btn-larger" type="submit"
                  value={editTrainer !== '' ? window.Drupal.t('fournisseur.gestion.submit.label') : window.Drupal.t('fournisseur.gestion.create.edit.modal.btn')} />
              </div>
            </form>
          </div>
        </div>
      </div>

      <CsfPivotalFournisseurFormateurListModal lists={lists} currentLists={listsBtns} />

    </div>
  );
}

CsfPivotalFournisseurFormateurModal.propTypes = {
  type: PropTypes.string,
  editTrainer: PropTypes.string,
  apiUrl: PropTypes.string,
  apiEnv: PropTypes.string,
  accessToken: PropTypes.string,
  handleAddCreateTrainerList: PropTypes.func,
  addToList: PropTypes.bool,
  listId: PropTypes.string,
  title: PropTypes.string,
  resetEditTrainer: PropTypes.func,
  ipfErrorMat: PropTypes.bool,
  isError: PropTypes.bool,
  setIpfErrorMat: PropTypes.func,
  setIsError: PropTypes.func
};
